import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true); setLoading(false);
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your account email and we'll send a reset link."
      footer={<Link to="/login" className="text-cyan-300 hover:underline">Back to sign in</Link>}>
      {sent ? (
        <div className="text-center py-6" data-testid="forgot-success">
          <span className="grid place-items-center w-14 h-14 rounded-full bg-emerald-500/20 text-emerald-400 mx-auto mb-4"><MailCheck className="w-7 h-7" /></span>
          <p className="text-slate-300">If that email is registered, a reset link has been sent. Please check your inbox.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div><Label className="text-slate-200 mb-1.5 block">Email</Label><Input data-testid="forgot-email" type="email" required className="bg-white/5 border-white/10 text-white" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
          <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-11 bg-violet-600 hover:bg-violet-500 text-white font-semibold">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
